export const PREFIX = 'APP';

export const UPDATE_SERVICE_WORKER = `${PREFIX}/UPDATE_SERVICE_WORKER`;
export const TOGGLE_MODAL_ALERT = `${PREFIX}/TOGGLE_MODAL_ALERT`;
